import React, {useEffect, useState} from 'react';
import useAuth from "../../hooks/useAuth";
import {fillNamesOfSumDays, getAllProducts, getAllProductsGlobal} from "./common";
import {Box, Card, CardContent, CircularProgress, useMediaQuery} from "@mui/material";
import ApexChart from "react-apexcharts";
import {formatEurPriceAndRoundUtil} from "../../utils/currencyUtil";
import localStrings from "../../localStrings";

function TopTenProducts({typeQuantity = false}) {
    const [sumUpDaysStructured, setSumUpDaysStructured] = useState(null);
    const [chartOptions, setChartOptions] = useState(null)
    const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));

    const {
        sumUpDays,
        categories,
        staffs,
        paymentModes,
        locations,
        products,
        optionLists,
        weatherDays,
        filter,
        currentEstablishment,
        loading,
    } = useAuth();


    useEffect(() => {
        if (!sumUpDays || sumUpDays.length === 0) {
            return;
        }
        if (!products || !staffs || !paymentModes || !locations || !categories) {
            return;
        }

        const structuredSumup = fillNamesOfSumDays(sumUpDays, staffs, locations,
            products, optionLists, paymentModes, categories);
        setSumUpDaysStructured(structuredSumup);

    }, [sumUpDays, products, staffs, paymentModes, locations, categories, optionLists])



    useEffect(() => {

            const fillData = async () => {
                // setLoading(true);
                if (!sumUpDaysStructured || !sumUpDays || !products || !staffs || !paymentModes || !locations || !categories) {
                    return;
                }
                try {

                    const res = await getApexChartData(
                        sumUpDaysStructured, weatherDays, filter
                    );

                    if (res) {
                        setChartOptions(res);
                    }

                } catch (e) {
                    console.error('Erreur lors de la récupération des données pour le graphique :', e);

                }
            }
            fillData();
        }
        , [sumUpDays, products, staffs, paymentModes, locations, categories, sumUpDaysStructured, filter])



    async function getApexChartData(sumUpDaysStructured, weatherDays, filter) {
        if (!filter || !sumUpDaysStructured || sumUpDaysStructured.length === 0) return;

        let productMap = {};

        // if (filter?.filterType === "filterSingleDay") {
        //     let timeSlotTotals = {};
        const allProducts = await getAllProductsGlobal(sumUpDaysStructured, currentEstablishment());

        allProducts.forEach((product) => {
            const name = product.name || "inconnu";
            if (!productMap[name]) productMap[name] = 0;
            let valueToSum = typeQuantity ? product.quantity : product.totalPrice;
            productMap[name] += valueToSum || 0; // correction ici : éviter double addition
        });

        const sortedEntries = Object.entries(productMap)
            .sort((a, b) => b[1] - a[1])
            .slice(0, 10); // ← Top 10

        const categories = sortedEntries.map(([name]) => name);
        const data = sortedEntries.map(([, value]) => value);

        return {
            series: [
                {
                    name: typeQuantity ? localStrings.quantity : localStrings.turnover,
                    data,
                },
            ],
            options: {
                chart: {
                    id: 'top-10-products',
                    type: 'bar',
                    height: 360,
                    toolbar: {
                        show: false,
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '50%',
                        borderRadius: 4,
                        dataLabels: {
                            position: 'top'
                        }
                    },
                },
                dataLabels: {
                    enabled: true,
                    offsetY: -20, // ✅ décalage vers le haut
                    style: {
                        fontSize: '12px',
                        colors: ['#000'] // noir, pour la lisibilité
                    },
                    formatter: (val) => typeQuantity
                        ? val
                        : formatEurPriceAndRoundUtil(val, lgUp),
                },
                xaxis: {
                    categories,
                    labels: {
                        style: {
                            fontSize: '13px'
                        }
                    }
                },
                yaxis: {
                    labels: {
                        formatter: (val) => typeQuantity
                            ? val.toFixed(0)
                            : formatEurPriceAndRoundUtil(val, lgUp)
                    },
                    title: {
                        text: typeQuantity ? localStrings.quantity : "Chiffre d'affaires (€)",
                    }
                },
                tooltip: {
                    y: {
                        formatter: (val) => typeQuantity
                            ? val
                            : formatEurPriceAndRoundUtil(val, lgUp),
                    },
                },
                colors: ['#42A5F5'],
                title: {
                    text: typeQuantity ? localStrings.topTenByQuantity : localStrings.topTenByTurnover,
                    align: 'left',
                    style: {
                        fontSize: '18px',
                    }
                }
            }
        };
    }




    return (
        <Card>
            {/*<p>{loading ? "Y" : "N"}</p>*/}
            <CardContent>
                {!loading ?
                    <>
                        {sumUpDaysStructured && sumUpDaysStructured.length > 0 && chartOptions  &&
                            <ApexChart
                                options={chartOptions.options}
                                series={chartOptions.series}
                                type={chartOptions.options?.chart?.type}
                                height={450}
                            />
                        }
                    </>
                    :
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '350px'
                    }}>
                        <CircularProgress size="100px" />
                    </Box>
                }
            </CardContent>
        </Card>
    )
}

export default TopTenProducts